
import { useIntl } from 'react-intl'

export function ComingSoon() {
  const intl = useIntl()
  return (
    <h1 className='text-dark display-1 pb-0'>{intl.formatMessage({id: `general.coming_soon`})}</h1>
  )
}
